import { render } from "./AddFriends.vue?vue&type=template&id=1ad9eb5e&scoped=true"
import script from "./AddFriends.vue?vue&type=script&lang=js"
export * from "./AddFriends.vue?vue&type=script&lang=js"

import "./AddFriends.vue?vue&type=style&index=0&id=1ad9eb5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad9eb5e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip,QBtn,QDialog,QCard,QCardSection,QSpace});
